// Import vue component
import FunctionalCalendar from './src/components/FunctionalCalendar.vue'

// Creating a module value for Vue.use ()
const FunctionalCalendarPlugin = {
  install(Vue, options = []) {
    Vue.prototype.$getOptions = function() {
      return options
    }

    Vue.component('FunctionalCalendar', FunctionalCalendar)
  },
  FunctionalCalendar
}

// Export component for use as a module (npm / webpack / etc.)
export default FunctionalCalendarPlugin
export { FunctionalCalendar }



//////////////////
// WEBPACK FOOTER
// ./~/vue-functional-calendar/index.js
// module id = 424
// module chunks = 0